<div class="h-full w-full si-card">
    <div class="flex flex-row grow-0 border-b px-4 py-2">
        <div class="flex grow items-center">
            <h3 class="pt-2 whitespace-nowrap">ICP</h3>
        </div>
        <ng-container *ngIf="(getIcpAgents$ | async) as agentsList">
            <div class="flex grow-0 items-center" *ngIf="agentsList.length !== 0">
                @if (!hideAgentSelector) {
                <button matButton="outlined" type="button" [matTooltip]="selectedOption?.name || 'All Agents'"
                    class="mat-small-button mr-1 card-menu si-menu-trigger" [matMenuTriggerFor]="intentAgentsMenu">
                    <span class="si-card-menu-content">
                        <span class="si-card-menu-label">{{ selectedOption?.name || 'All Agents' }}</span>
                        <span class="si-menu-trigger-icon" aria-hidden="true"></span>
                    </span>
                </button>
                <mat-menu #intentAgentsMenu>
                    <ng-template matMenuContent>
                        <button mat-menu-item (click)="updateSelectedOption(null)">
                            All Agents
                        </button>
                        <button mat-menu-item *ngFor="let agent of agentsList" (click)="updateSelectedOption(agent)">
                            {{agent.name}}
                        </button>
                    </ng-template>
                </mat-menu>
                }
                <mat-button-toggle-group name="type" class="mr-1 card-toggle-btn">
                    <mat-button-toggle value="CHART" [checked]="isShowChart"
                        (click)="isShowChart = true" class="flex items-center">
                        <fa-icon matTooltip="Chart" class="si-icon" [icon]="['fal', 'chart-column']"></fa-icon>
                    </mat-button-toggle>
                    <mat-button-toggle value="TABLE" [checked]="!isShowChart"
                        (click)="isShowChart = false" class="flex items-center">
                        <fa-icon matTooltip="Table" class="si-icon" [icon]="['fal', 'table']"></fa-icon>
                    </mat-button-toggle>
                </mat-button-toggle-group>
                <div [matTooltip]="!selectedOption ? 'View all only available when an individual ICP Agent is selected.' : (isWeeklyAgentsNotRun ? 'View all is disabled while this agent has not run yet.' : '')">
                    <button matButton="outlined" type="button" class="mat-small-button card-btn" [disabled]="!selectedOption || isWeeklyAgentsNotRun" (click)="showReport()">
                    View All
                    </button>
                </div>
            </div>
        </ng-container>
    </div>
    <div *ngIf="(isIcpLoading$ | async); else showIcpDetails"
        class="flex justify-center items-center h-full w-full">
        <mat-spinner></mat-spinner>
    </div>
    <ng-template #showIcpDetails>
        <div class="flex flex-col h-full w-full p-4 relative overflow-hidden">
            <ng-container *ngIf="(getIcpAgents$ | async) as agentsList">

                <ng-container *ngIf="agentsList.length !== 0; else noAgentsCreated">
                    <app-icp-card class="flex flex-col h-full overflow-hidden w-full" [isShowChart]="isShowChart"
                        [selectedOption]="selectedOption" [combinedSummary]="icpMonthlyCombinedSummary"
                        [exportSummary]="icpMonthlyExportSummary" [emailOnlySummary]="icpMonthlyReportSummary"></app-icp-card>
                </ng-container>

                <ng-template #noAgentsCreated>
                    <div class="h-full w-full p-4 content-center text-center font-bold">
                        <h5>You do not currently have any ICP Agents created.</h5>
                        <p class="text-base text-muted">
                            <ng-container *ngIf="featureFlagsEnum.GTMCanvas | isFeatureFlagEnabled | async; else legacyLink">
                                <a [routerLink]="resultTabsetUrlsEnum.AGENTIC_WORKFLOWS">Create an ICP Agent</a>
                            </ng-container>
                            <ng-template #legacyLink>
                                <a href="javascript:;" (click)="onOpenIcpSettings()">Create an ICP Agent</a>
                            </ng-template>
                            to
                            easily see and/or export any new companies or contacts that fit your ideal customer profile.</p>
                    </div>
                </ng-template>
            </ng-container>
        </div>
    </ng-template>
</div>
